import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = { class: "min-w-0" };
const _hoisted_3 = { class: "block truncate font-semibold text-eblack-900" };
const _hoisted_4 = { class: "block truncate text-xs text-eblack-500" };
const _hoisted_5 = {
    key: 0,
    class: "absolute bottom-full left-0 z-50 mb-2 w-full overflow-hidden rounded-xl border border-ewhite-200 bg-white shadow-xl"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "min-w-0" };
const _hoisted_8 = { class: "block truncate font-medium text-eblack-900" };
const _hoisted_9 = { class: "block truncate text-xs text-eblack-500" };
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { IconBuilding, IconChevronDown } from "@tabler/icons-vue";
import { useAuthStore } from "@/domains/auth";
import { useOrganizationContextSwitch } from "../composables";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrgSwitcher',
    setup(__props) {
        const authStore = useAuthStore();
        const router = useRouter();
        const contextSwitch = useOrganizationContextSwitch();
        const isOpen = ref(false);
        const currentName = computed(() => authStore.currentOrgName);
        const currentRole = computed(() => authStore.currentMembership?.role_label ?? "");
        function handleSelect(orgId) {
            const membership = authStore.activeMemberships.find((item) => String(item.org_id) === orgId);
            if (!membership)
                return;
            contextSwitch.switchToMembershipOrg(membership);
            isOpen.value = false;
            router.push("/admin");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    type: "button",
                    class: "flex w-full items-center justify-between rounded-xl border border-ewhite-200 bg-white px-3 py-2 text-left text-sm text-eblack-700 transition hover:bg-ewhite-50",
                    onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = !isOpen.value))
                }, [
                    _createElementVNode("span", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(currentName.value || 'Sin organización'), 1),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(currentRole.value || 'Seleccione contexto'), 1)
                    ]),
                    _createVNode(_unref(IconChevronDown), { class: "h-4 w-4 flex-shrink-0 text-eblack-500" })
                ]),
                (isOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authStore).activeMemberships, (membership) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: membership.org_id,
                                type: "button",
                                class: _normalizeClass(["flex w-full items-start gap-2 px-3 py-2 text-left text-sm hover:bg-ewhite-50", String(membership.org_id) === String(_unref(authStore).currentOrgId) ? 'bg-eorange-50' : '']),
                                onClick: ($event) => (handleSelect(String(membership.org_id)))
                            }, [
                                _createVNode(_unref(IconBuilding), { class: "mt-0.5 h-4 w-4 text-eorange-500" }),
                                _createElementVNode("span", _hoisted_7, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(membership.org_name), 1),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(membership.role_label), 1)
                                ])
                            ], 10, _hoisted_6));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
